import React from 'react'
import TextLink from 'components/Luxkit/TextLink'
import BodyText from 'components/Luxkit/Typography/BodyText'
import styled from 'styled-components'
import { rem } from 'polished'
import LineClockDollarIcon from 'components/Luxkit/Icons/line/LineClockDollarIcon'
import { mediaQueryUp } from 'components/utils/breakpoint'
import useToggle from 'hooks/useToggle'
import FormatCurrency from '../FormatCurrency'
import Breakpoint from '../Breakpoint'
import PayInInstalmentsMoreInfoModal from '../PayInInstalmentsInfo/PayInInstalmentsMoreInfoModal'

const Container = styled.div`
  background-color: ${props => props.theme.palette.highlight.primary.light};
  border-radius: ${props => props.theme.borderRadius.large};
  display: flex;
  padding: ${rem(16)};
`

const RightSide = styled.div`
  margin-left: ${rem(8)};

  ${mediaQueryUp.desktop} {
    display: flex;
    align-items: center;
  }
`

const Divider = styled.div`
  margin-left: ${rem(8)};
  border-left: ${rem(1)} solid;
  height: 100%;
  width: ${rem(1)};
  color: ${props => props.theme.palette.neutral.two};
`

const StyledBodyText = styled(BodyText)`
  ${mediaQueryUp.desktop} {
    margin-left: ${rem(8)};
  }

`

const StyledLink = styled(TextLink)`
  ${mediaQueryUp.desktop} {
    margin-left: ${rem(8)};
  }
`

interface Props {
  depositPercentage: number
  instalmentWeeklyAmount: number
}

export function SecureWithFlexiblePaymentsBanner({ depositPercentage, instalmentWeeklyAmount }: Props) {
  const [showModal, _, openModal, onCloseModal] = useToggle(false)

  return (
    <>
      <Container>
        <LineClockDollarIcon colour="primary" />
        <RightSide>
          <BodyText variant="medium" weight="bold">
            Secure with {depositPercentage}% deposit
          </BodyText>
          <Breakpoint min="desktop">
            <Divider />
          </Breakpoint>
          <StyledBodyText variant="medium">
            Pay the rest later with a payment plan that suits you.
            {!!instalmentWeeklyAmount &&
              <>
                {' '}
                Starting from <FormatCurrency value={instalmentWeeklyAmount} />/week.
              </>
            }
          </StyledBodyText>
          <StyledLink onClick={openModal} size="medium">Learn more</StyledLink>
        </RightSide>
      </Container>
      <PayInInstalmentsMoreInfoModal
        isPolicyOpen={showModal}
        closePolicy={onCloseModal}
        depositPercentage={depositPercentage}/>
    </>
  )
}
